import { createEntityComboBox } from './helpers/createEntityComboBox';
import {
  formatSupplierAddress,
  useSupplierLocationPairQuery,
} from './SelectSupplierLocationPairTouch';

export const SelectSupplierLocationPair = createEntityComboBox.remotelySearched(
  'SelectSupplierLocationPair',
  useSupplierLocationPairQuery,
  {
    formatLabel: (entity) =>
      (entity.account?.name ?? 'Unknown') +
      (entity.name ? ' — ' + entity.name : ''),
    formatSubLabel: (entity) => formatSupplierAddress(entity),
  },
);
